import type { QueryKey } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { SynchronousQueryConfig } from 'lib/react-query';
import queryKeys from './queryKeys';
import { apiClient } from 'lib/api';

interface UniqueIdEntry {
  unique_id: string;
}

interface UniqueIdEntryResponse {
  data: UniqueIdEntry;
}

export const getUniqueId = async (
  signal?: AbortSignal,
): Promise<UniqueIdEntry> => {
  const res = await apiClient.get<UniqueIdEntryResponse>(queryKeys.uniqueId, {
    signal,
  });

  return res.data.data;
};

interface UseCampaignIdOptions<TData> {
  config?: SynchronousQueryConfig<typeof getUniqueId, TData>;
}

export const useUniqueId = <TData = UniqueIdEntry>
({
   config,
 }: UseCampaignIdOptions<TData> = {}) => {
  return useQuery({
    staleTime: 60 * 30 * 1000,
    ...config,
    queryFn: ({ signal }) => getUniqueId(signal),
    queryKey: [queryKeys.uniqueId] as QueryKey,
  });
};
